var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 16.6666H4.83366C3.90024 16.6666 3.43353 16.6666 3.07701 16.4849C2.7634 16.3251 2.50844 16.0702 2.34865 15.7566C2.16699 15.4 2.16699 14.9333 2.16699 13.9999V5.99992C2.16699 5.0665 2.16699 4.59979 2.34865 4.24327C2.50844 3.92966 2.7634 3.6747 3.07701 3.51491C3.43353 3.33325 3.90024 3.33325 4.83366 3.33325H5.16699C7.03383 3.33325 7.96725 3.33325 8.68029 3.69656C9.3075 4.01614 9.81744 4.52608 10.137 5.15328C10.5003 5.86632 10.5003 6.79974 10.5003 8.66659M10.5003 16.6666V8.66659M10.5003 16.6666H16.167C17.1004 16.6666 17.5671 16.6666 17.9236 16.4849C18.2372 16.3251 18.4922 16.0702 18.652 15.7566C18.8337 15.4 18.8337 14.9333 18.8337 13.9999V5.99992C18.8337 5.0665 18.8337 4.59979 18.652 4.24327C18.4922 3.92966 18.2372 3.6747 17.9236 3.51491C17.5671 3.33325 17.1004 3.33325 16.167 3.33325H15.8337C13.9668 3.33325 13.0334 3.33325 12.3204 3.69656C11.6932 4.01614 11.1832 4.52608 10.8636 5.15328C10.5003 5.86632 10.5003 6.79974 10.5003 8.66659",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue);
export default __webpack_public_path__ + "static/media/catalogue.a310866b29c0021efca7e5909ec5f4e7.svg";
export { ForwardRef as ReactComponent };